import { type FC } from 'react';
import { FaLongArrowAltLeft, FaLongArrowAltRight } from 'react-icons/fa';

import IconButton from '../IconButton';
import { conflictsNavigation } from './styles';

interface Props {
	currentIndex: number;
	conflictsNumber: number;
	setCurrentIndex: (index: number) => void;
}

const Navigation: FC<Props> = (props) => {
	const { currentIndex, conflictsNumber, setCurrentIndex } = props;

	return (
		<div className={conflictsNavigation}>
			<IconButton
				disabled={currentIndex < 1}
				ariaLabel="previous"
				onClick={() => setCurrentIndex(currentIndex - 1)}>
				<FaLongArrowAltLeft />
			</IconButton>
			<span>
				{currentIndex + 1} / {conflictsNumber}
			</span>
			<IconButton
				disabled={currentIndex + 1 >= conflictsNumber}
				ariaLabel="next"
				onClick={() => setCurrentIndex(currentIndex + 1)}>
				<FaLongArrowAltRight />
			</IconButton>
		</div>
	);
};

export default Navigation;
